module.exports = __webpack_public_path__ + "media/images/icon-telehealth-42ae6782032dac5bdb0962d34806ec45.png";